"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
var __metadata = (this && this.__metadata) || function (k, v) {
    if (typeof Reflect === "object" && typeof Reflect.metadata === "function") return Reflect.metadata(k, v);
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var react_dom_1 = __importDefault(require("react-dom"));
var classnames_1 = __importDefault(require("classnames"));
var mobx_react_1 = require("mobx-react");
var mobx_1 = require("mobx");
var Types_1 = require("Tokens/Types");
var WidgetManager_1 = require("../../WidgetManager");
var EditorTypes_1 = require("Project/QwilrEditor/EditorTypes");
var icons_1 = require("@qwilr/kaleidoscope/icons");
var TokenMenu_1 = require("Project/QwilrEditor/Widgets/TokenMenu/TokenMenu");
var WidgetMenuButton_1 = __importDefault(require("Project/QwilrEditor/Widgets/WidgetMenuButton"));
var Types_2 = require("@CommonFrontendBackend/ContentTokens/Types");
var WidgetToolbarPositioning_1 = require("Project/QwilrEditor/Widgets/WidgetToolbarPositioning");
var WidgetTokenDropArea_1 = require("../WidgetTokenDropArea/WidgetTokenDropArea");
var Types_3 = require("@CommonFrontendBackend/Tokens/Types");
var VariableActions_1 = require("Project/QwilrEditor/Behaviours/VariableActions");
var TokenSearchContext_1 = __importDefault(require("Project/QwilrEditor/Providers/TokenScope/TokenSearchContext"));
var Types_4 = require("ContentTokens/Models/inputs/Types");
var SubstitutionTokenFactory_1 = __importDefault(require("Tokens/SubstitutionTokenFactory"));
var ContentLoopWidget = (function (_super) {
    __extends(ContentLoopWidget, _super);
    function ContentLoopWidget() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this._isShowingVariableSelection = false;
        _this.readyToRenderToolbar = false;
        _this.handleSelect = function (event) {
            if (_this.props.isSelected) {
                return;
            }
            event.preventDefault();
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_2.WidgetBlockType.ContentLoop, {
                action: EditorTypes_1.ContentLoopActionType.SelectContentLoop,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.handleDelete = function () {
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_2.WidgetBlockType.ContentLoop, {
                action: EditorTypes_1.ContentLoopActionType.DeleteContentLoop,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.handleSetVariable = function (token) {
            if (!(0, Types_1.isListToken)(token)) {
                return;
            }
            var repeatingToken = new Types_4.RepeatingTokenInput(token.apiName, token.name, token.childObjectType, token.childPropertyLabel, SubstitutionTokenFactory_1.default.fromLegacyApiToken(token));
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_2.WidgetBlockType.ContentLoop, {
                action: EditorTypes_1.ContentLoopActionType.SetContentLoopVariable,
                path: _this.props.widgetManager.getPath(_this.props.element),
                variable: repeatingToken,
            }));
        };
        _this.handleRemoveVariable = function () {
            _this.toggleVariableSelection(false);
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_2.WidgetBlockType.ContentLoop, {
                action: EditorTypes_1.ContentLoopActionType.RemoveContentLoopVariable,
                path: _this.props.widgetManager.getPath(_this.props.element),
            }));
        };
        _this.handleDropAreaClick = function (event) {
            _this.handleSelect(event);
            setTimeout(function () {
                _this.toggleVariableSelection(true);
            });
        };
        _this.handleTokenDrop = function (event) {
            event.preventDefault();
            event.stopPropagation();
            var variable = (0, VariableActions_1.getVariableTokenFromDragEvent)(event);
            if (!variable || (variable === null || variable === void 0 ? void 0 : variable.dataType) !== Types_3.TokenDataType.List) {
                return;
            }
            _this.props.widgetManager.triggerEvent(new WidgetManager_1.WidgetEvent(Types_2.WidgetBlockType.ContentLoop, {
                action: EditorTypes_1.ContentLoopActionType.DropContentLoopVariable,
                path: _this.props.widgetManager.getPath(_this.props.element),
                variable: variable,
            }));
        };
        _this.isSupportedDragType = function (event) {
            var variable = (0, VariableActions_1.getVariableTokenFromDragEvent)(event);
            return (variable === null || variable === void 0 ? void 0 : variable.dataType) === Types_3.TokenDataType.List;
        };
        return _this;
    }
    Object.defineProperty(ContentLoopWidget.prototype, "hasVariable", {
        get: function () {
            return !!this.props.variable;
        },
        enumerable: false,
        configurable: true
    });
    Object.defineProperty(ContentLoopWidget.prototype, "isShowingVariableSelection", {
        get: function () {
            return this.hasVariable || this._isShowingVariableSelection;
        },
        enumerable: false,
        configurable: true
    });
    ContentLoopWidget.prototype.toggleVariableSelection = function (show) {
        this._isShowingVariableSelection = show;
    };
    ContentLoopWidget.prototype.componentDidMount = function () {
        this.readyToRenderToolbar = true;
    };
    ContentLoopWidget.prototype.componentDidUpdate = function (prevProps) {
        if (prevProps.isSelected && !this.props.isSelected) {
            this.toggleVariableSelection(false);
        }
    };
    ContentLoopWidget.prototype.render = function () {
        var _a = this.props, children = _a.children, attributes = _a.attributes, isSelected = _a.isSelected, enableTokens = _a.enableTokens;
        var instructions = enableTokens === Types_1.TokensEnableState.EnabledWithAllInteractions
            ? "Click or drag to select a repeating token. Content will repeat for each item in the token."
            : "Click to select a repeating token. Content will repeat for each item in the token.";
        return (react_1.default.createElement("div", __assign({ className: "content-loop-widget" }, attributes),
            react_1.default.createElement("div", { className: "content-loop-widget__inner-wrapper" },
                isSelected && this.renderToolbar(),
                this.renderSelector(),
                !this.hasVariable && (react_1.default.createElement(WidgetTokenDropArea_1.WidgetTokenDropArea, { borderless: true, size: WidgetTokenDropArea_1.WidgetTokenDropAreaSize.Medium, isSelected: isSelected, onDrop: this.handleTokenDrop, onDropAreaClick: this.handleDropAreaClick, instructions: instructions, customDragDrop: {
                        isSupportedType: this.isSupportedDragType,
                        customDragMessage: "Release to add repeating token",
                    }, icon: icons_1.Loop })),
                react_1.default.createElement("div", { className: (0, classnames_1.default)("content-loop-widget__content", {
                        "content-loop-widget__content--visible": this.hasVariable,
                    }) },
                    react_1.default.createElement(TokenSearchContext_1.default.Provider, { value: this.props.variable }, children)))));
    };
    ContentLoopWidget.prototype.renderToolbar = function () {
        var _this = this;
        var _a = this.props, variable = _a.variable, widgetToolbarHost = _a.widgetToolbarHost;
        var toolbarHost = widgetToolbarHost.current;
        if (!this.readyToRenderToolbar || !toolbarHost) {
            return;
        }
        return react_dom_1.default.createPortal(react_1.default.createElement(WidgetToolbarPositioning_1.WidgetToolbarPositioning, { widgetRef: this.props.attributes.ref }, function (_a) {
            var toolbarPosition = _a.toolbarPosition, toolbarRef = _a.toolbarRef;
            return (react_1.default.createElement("div", { className: "content-loop-widget__toolbar editor-toolbar", style: _this.getToolbarPosition(toolbarPosition), ref: toolbarRef },
                _this.isShowingVariableSelection ? (react_1.default.createElement(TokenMenu_1.TokenMenu, { type: Types_3.TokenDataType.List, token: variable ? __assign(__assign({}, variable), { type: Types_3.TokenDataType.List }) : undefined, removeToken: _this.handleRemoveVariable, confirmToken: _this.handleSetVariable, close: function () { return _this.toggleVariableSelection(false); } })) : (react_1.default.createElement(WidgetMenuButton_1.default, { tooltipMessage: "Add token", icon: react_1.default.createElement(icons_1.Tokens, null), onMouseDown: function () { return _this.toggleVariableSelection(true); } })),
                react_1.default.createElement(WidgetMenuButton_1.default, { customClass: "content-loop-widget__toolbar-button--delete", tooltipMessage: "Delete", icon: react_1.default.createElement(icons_1.Delete, null), onMouseDown: _this.handleDelete, isDestructive: true })));
        }), toolbarHost);
    };
    ContentLoopWidget.prototype.renderSelector = function () {
        return (react_1.default.createElement("div", { className: (0, classnames_1.default)("content-loop-widget__selector", {
                "content-loop-widget__selector--selected": this.props.isSelected,
            }), contentEditable: false, onMouseDown: this.handleSelect }));
    };
    ContentLoopWidget.prototype.getToolbarPosition = function (toolbarPosition) {
        var _a, _b;
        return {
            position: "fixed",
            top: "".concat((_a = toolbarPosition === null || toolbarPosition === void 0 ? void 0 : toolbarPosition.overlay.top) !== null && _a !== void 0 ? _a : 0, "px"),
            left: "".concat((_b = toolbarPosition === null || toolbarPosition === void 0 ? void 0 : toolbarPosition.overlay.left) !== null && _b !== void 0 ? _b : 0, "px"),
        };
    };
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ContentLoopWidget.prototype, "_isShowingVariableSelection", void 0);
    __decorate([
        mobx_1.observable.ref,
        __metadata("design:type", Object)
    ], ContentLoopWidget.prototype, "readyToRenderToolbar", void 0);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ContentLoopWidget.prototype, "hasVariable", null);
    __decorate([
        mobx_1.computed,
        __metadata("design:type", Boolean),
        __metadata("design:paramtypes", [])
    ], ContentLoopWidget.prototype, "isShowingVariableSelection", null);
    __decorate([
        mobx_1.action.bound,
        __metadata("design:type", Function),
        __metadata("design:paramtypes", [Boolean]),
        __metadata("design:returntype", void 0)
    ], ContentLoopWidget.prototype, "toggleVariableSelection", null);
    ContentLoopWidget = __decorate([
        mobx_react_1.observer
    ], ContentLoopWidget);
    return ContentLoopWidget;
}(react_1.default.Component));
exports.default = ContentLoopWidget;
